import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCommentDTO } from '@app/_models/add-comment-dto';
import { KhcService } from '@app/_services/khc.service';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.component.html',
  styleUrls: ['./comment-modal.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzModalModule
  ]
})
export class CommentModalComponent implements OnInit {
  private khcService = inject(KhcService);


  @Input()
  value!: number;

  @Output()
  valueUpdated = new EventEmitter<number>;

  isVisible = false;

  valueForm = new FormGroup({
    value: new FormControl()
  });

  constructor() {
    console.log('contructor...');
  }

  ngOnInit(): void {
    console.log('modal...');
  }

  showModal() {
    this.isVisible = true;
  }

  handleCancel() {
    this.isVisible = false;
  }

  handleOk() {
    const add = {
      entityId: '123',
      type: 'section0',
      comment: 'hello',
      authorId: 'authorId',
      authorIin: 'authorIin',
      authorEmail: 'authorEmail',
      authorLastName: 'authorLastName',
      authorFirstName: 'authorFirstName',
      authorFatherName: 'authorFatherName'
    } as AddCommentDTO;

    this.khcService.addComment(add).subscribe(
      data => {
        this.isVisible = false;
      }
    );
  }
}
